module.exports = __webpack_public_path__ + "static/Attia-a44a8d77d0d80556352112d894324987.png";